export default "__VITE_ASSET__DKj8DvYi__"